<template>
  <div class="content-text">
    <h2 class="title-2 text-left">9 ENTENDENDO OS RECURSOS DA APS NO FNS</h2>

    <p>
      Como previsto na Portaria nº 3493, o cofinanciamento federal da APS
      começou a ser pago na parcela financeira maio de 2024. A seguir, está a
      forma de relacionar os valores do FNS com as regras estabelecidas no
      cofinanciamento federal da APS.
    </p>

    <p>
      Esta análise leva em consideração os recursos referentes a um mês a
      começar do mês de maio de 2024.
    </p>

    <h2 class="title-3 text-left">9.1 ESF e EAP na APS</h2>

    <p>
      No FNS, observando-se a <b>ação detalhada</b> “INCENTIVO FINANCEIRO DA APS
      - EQUIPES DE SAÚDE DA FAMÍLIA/ESF E EQUIPES DE ATENÇÃO PRIMÁRIA/EAP”, o
      detalhamento dos recursos fica conforme apresenta o quadro 10, onde
      leva-se em consideração somente os recursos dos componentes relacionados
      às equipes do tipo eSF e eAP. Não se deve desconsiderar outras equipes e
      serviços ao interpretar o recurso mencionado, exceto o valor que o
      município paga por coparticipação no Mais Médicos, quando houver.
    </p>

    <div class="container-table">
      <span style="text-transform: uppercase; font-weight: bold"
        >Quadro 10 - DETALHAMENTO DO RECURSO DE INCENTIVO FINANCEIRO DA APS -
        EQUIPES DE SAÚDE DA FAMÍLIA/ESF E EQUIPES DE ATENÇÃO PRIMÁRIA/EAP DO FNS
      </span>
      <table>
        <thead>
          <tr>
            <th>COMPONENTES POR ESF E EAP</th>
            <th>VALOR POR COMPONENTE</th>
          </tr>
        </thead>
        <tbody>
          <!-- <tr>
            <td>Fixo de implantação</td>
            <td>-</td>
            <td class="text-right">
              R$
              {{
                valorFixoImplantacao.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
          </tr> -->
          <tr>
            <td>Equidade</td>
            <td class="text-center">
              R$
              {{
                fixo.valorCusteio.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
          </tr>
          <tr>
            <td>Vínculo e acompanhamento territorial</td>
            <td class="text-center">
              R$
              {{
                valorVinculoAcompanhamento.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
          </tr>
          <tr>
            <td>Qualidade</td>
            <td class="text-center">
              R$
              {{
                valorQualidade.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
          </tr>
          <!-- <tr>
            <td>*Coparticipação mais médicos</td>
            <td>-</td>
            <td class="text-center red">
              -R$
              {{
                valorCoparticipacaoMedicos.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
          </tr> -->
          <tr class="grey">
            <td><strong>Total</strong></td>
            <td class="text-center">
              <strong>
                R$
                {{
                  totalGeral.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                  })
                }}</strong
              >
            </td>
          </tr>
        </tbody>
      </table>
      <span class="fonte" v-html="fonte"></span>
    </div>

    <p>
      *Cada médico que faz parte da coparticipação no programa Mais Médicos,
      gera um desconto de R$ 12.386,50 (doze mil, trezentos e oitenta e seis
      reais e cinquenta centavos) no repasse federal ao município. Esse valor é
      utilizado pelo Ministério da Saúde para pagar os profissionais que estão
      em atuação no programa.
    </p>
  </div>
</template>

<script>
import { regras, getLabelRegra } from '../utils.js'

export default {
  props: {
    dados: {
      type: Object,
      default: () => {},
    },
    fixo: {
      type: Object,
      default: () => {},
    },
    vinculoAcompanhamento: {
      type: Array,
      default: () => [],
    },
    fonte: {
      type: String,
      default: '',
    },
    classificacao: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  computed: {
    valorVinculoAcompanhamento() {
      return Number(this.dados?.etapa4?.totalCVAT || 0)
    },

    /**
     * Retorna apenas o valor de qualidade das equipes eSF e eAP.
     *
     * @returns {number}
     */
    valorQualidade() {
      const equipes = this.dados?.etapa4?.equipes || []

      return equipes
        .filter((item) => {
          return (
            item.componente !== 'CVAT' &&
            ['eSF', 'eAP 20h', 'eAP 30h'].includes(item.equipe)
          )
        })
        .reduce((total, item) => {
          return total + Number(item.valorTotal || 0)
        }, 0)
    },

    totalGeral() {
      return (
        Number(this.fixo?.valorCusteio || 0) +
        this.valorVinculoAcompanhamento +
        this.valorQualidade
      )
    },
  },
  methods: {},
}
</script>

<style lang="scss"></style>
